<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>{{ method === "post" ? "Add" : "Edit" }} Payment Method</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form
          :fields="paymentProvider"
          :method="method"
          :action="url"
          @submitted="$emit('changed', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-input name="name" label="Payment Method Name" />
              </v-col>
              <v-col cols="12">
                <custom-select
                  name="payment_types"
                  :items="types"
                  item-text="name"
                  item-value="id"
                  label="Payment Types"
                  multiple
                />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-plus</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  {{ method === "post" ? "Add" : "Edit" }}
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    method: { default: "post", type: String },
    paymentProvider: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      types: [],
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    url() {
      if (this.paymentProvider && this.paymentProvider.id) {
        return `api/v1/transactions/transferPaymentProviders/${this.paymentProvider.id}`;
      }
      return "api/v1/transactions/transferPaymentProviders";
    },
  },
  methods: {
    fetchData() {
      this.getTransferPaymentTypes();
    },
    getTransferPaymentTypes() {
      return this.$http
        .get("/api/v1/transactions/transferPaymentTypes")
        .then(({ data }) => (this.types = data));
    },
  },
};
</script>
